// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"54ba2dcc","453":"b29ebad4","732":"224811ce","977":"805307f7"}[chunkId] + ".chunk.js";
};